import { render, staticRenderFns } from "./hdraces.vue?vue&type=template&id=1b4a7536&scoped=true"
import script from "./hdraces.vue?vue&type=script&lang=js"
export * from "./hdraces.vue?vue&type=script&lang=js"
import style0 from "./hdraces.vue?vue&type=style&index=0&id=1b4a7536&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4a7536",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/hdraces.vue
// module id = /3N6
// module chunks = 0